var _path, _mask, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticleMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 160,
    viewBox: "0 0 167 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.3726 5.37258 0 12 0H155C161.627 0 167 5.37258 167 12V116.9H0V12Z",
    fill: "#474747"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_469_338",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 117H167V147C167 153.627 161.627 159 155 159H12C5.37258 159 0 153.627 0 147V117Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 117H167V147C167 153.627 161.627 159 155 159H12C5.37258 159 0 153.627 0 147V117Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 117H167H0ZM168 147C168 154.18 162.18 160 155 160H12C4.8203 160 -1 154.18 -1 147H1C1 153.075 5.92487 158 12 158H155C161.075 158 166 153.075 166 147H168ZM12 160C4.8203 160 -1 154.18 -1 147V117H1V147C1 153.075 5.92487 158 12 158V160ZM168 117V147C168 154.18 162.18 160 155 160V158C161.075 158 166 153.075 166 147V117H168Z",
    fill: "#EBEBEB",
    mask: "url(#path-2-inside-1_469_338)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6803 159.154H12C5.37258 159.154 0 153.782 0 147.154V74.4928C0.000924698 74.4929 0.0018494 74.4931 0.00277412 74.4932C6.6585 75.5288 13.4432 72.7893 17.4347 67.3636C24.6578 57.5455 39.3355 57.5455 46.5585 67.3636C50.5501 72.7893 57.3348 75.5288 63.9905 74.4932C75.9312 72.6353 86.4495 82.9213 84.555 94.8563C83.5016 101.493 86.2742 108.159 91.7246 112.09C101.578 119.195 101.578 133.865 91.7245 140.97C86.2742 144.901 83.5016 151.567 84.555 158.204C84.6055 158.522 84.6472 158.839 84.6803 159.154Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleMobile);
export default __webpack_public_path__ + "static/media/article-mobile.cf8b91cb36572ee736e13a7538e07a67.svg";
export { ForwardRef as ReactComponent };